// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1amEx","rootSuccess":"CompleteLink_rootSuccess__2gYnb","rootFailure":"CompleteLink_rootFailure__2qiOH","isDisabled":"CompleteLink_isDisabled__15KiH"};